<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Empty layout -->
<!-- ----------------------------------------------------------------------------------------------------- -->
<empty-layout *ngIf="layout === 'empty'"></empty-layout>

<classic-layout *ngIf="layout === 'classic'"></classic-layout>

<compact-layout *ngIf="layout === 'compact'"></compact-layout>

